import { Component, Shark, Utils } from "shark-mvc";

import templateContent from "./related-contents.html";

import contentFinderComponent from "../contentFinder/contentFinderComponent";
import waitBoxComponent from "../waitBox/waitBoxComponent";

class RelatedContentsComponent extends Component {
	constructor () {
		super("relatedContentsComponent");

		this.addTemplate("", templateContent);
	}

	addRelatedContent (data) {
		console.log(data);

		if (Shark.$store.currContent && data.guid && !Shark.$store.currContent.relatedContents.find(item => item.guid === data.guid)) {
			Shark.$store.currContent.relatedContents.push({
				guid: data.guid,
				title: data.title,
				type: data.contentType,
			});
			
			Shark.render();
		}
	}

	beforeLoad () {
		// contentFinderComponent.on("content_selected", this.contentFinderComponent_content_selectedHandler);
	}

	beforeUnload () {
		contentFinderComponent.resetContentFinderSearchField();
		// contentFinderComponent.off("content_selected", this.contentFinderComponent_content_selectedHandler);
	}

	contentFinderComponent_content_selectedHandler (event, data) {
		relatedContentsComponent.addRelatedContent(data);
		//contentFinderComponent.resetContentFinderSearchField();
	}

	deleteAllRelatedContent () {
		if (confirm(`Vuoi davvero cancellare tutti i Contenuti correlati a "${Shark.$store.currContent.title}"`)) {
			Shark.$store.currContent.set({
				relatedContents: [],
			});
			Shark.render();
		}
	}
	
	deleteAllRelatedContentBtn_clickHandler () {
		this.deleteAllRelatedContent();
	}

	deleteRelatedContent (guid) {
		const relatedContent = Utils.safp(Shark.$store.currContent.relatedContents, "guid", guid);

		if (relatedContent && confirm(`Sei sicuro di voler disassociare "${relatedContent.title}" da "${Shark.$store.currContent.title}"`)) {
			Shark.$store.currContent.set({
				relatedContents: Shark.$store.currContent.relatedContents.filter(item => item.guid !== guid),
			});
			Shark.render();
		}
	}

	deleteRelatedContentBtn_clickHandler (event, data) {
		if (data.guid !== "") {
			this.deleteRelatedContent(data.guid);
		}
	}

	init () {
		this.addComponents([contentFinderComponent]);

		// contentFinderComponent.on("content_selected", (event, data) => {
		// 	this.addRelatedContent(data);
		// 	contentFinderComponent.resetContentFinderSearchField();
		// });

		// const relatedLinksData = Shark.getInstance("__smart__", {
		// 	linkURL: "",
		// 	linkTitle: "",
		// 	__linkProtocol: "https://",
		// });

		// Shark.set({
		// 	relatedLinksData,
		// 	searchResultImageContentList: [],
		// 	searchResultPlaceContentList: [],
		// });
	}
	
	viewContent (content) {
		let targetView;

		switch (content.type) {
			case "image":
				targetView = "imageContentView";
				break;
			case "place":
				targetView = "placeContentView";
				break;
			case "text":
				targetView = "textContentView";
				break;
		}

		waitBoxComponent.open();
		Shark.set({ currContent: null });
		Shark.openPage(targetView, { urlSearchParams: { coguid: content.guid } });
	}

	viewRelatedContentBtn_clickHandler (event, data) {
		const { currContent } = Shark.get();

		console.log({currContent});

		if (!currContent.isDirty() || confirm(`Ci sono delle modifiche non salvate, se prosegui andranno perdute.\n\nVuoi davvero proseguire?`)) {
			this.viewContent(data);
		}
	}

	viewRelatorContentBtn_clickHandler (event, data) {
		const { currContent } = Shark.get();

		if (!currContent.isDirty() || confirm(`Ci sono delle modifiche non salvate, se prosegui andranno perdute.\n\nVuoi davvero proseguire?`)) {
			currContent.restore();
			this.viewContent(data);
		}
	}
}

const relatedContentsComponent = new RelatedContentsComponent();

Shark.registerComponent(relatedContentsComponent);

export default relatedContentsComponent;
